export function isMobileDevice() {
    return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1);
}

export function copyTextToClipboard(copyText) {
    return new Promise((resolve, reject) => {
        if (navigator.clipboard) {
            navigator.clipboard.writeText(copyText).then(() => {
                resolve();
            }, (err) => {
                console.error('Async: Could not copy text: ', err);
                reject();
            });
        } else {
            const isIphone = navigator.userAgent.match(/ipad|iphone/i);
            if (this.input) {
                let range;
                let selection;
                if (isIphone) {
                    range = document.createRange();
                    range.selectNodeContents(this.input);
                    selection = window.getSelection();
                    selection.removeAllRanges();
                    selection.addRange(range);
                    this.input.setSelectionRange(0, 999999);
                } else {
                    this.input.select();
                }
                try {
                    document.execCommand('copy');
                } catch (err) {
                    console.error(err);
                }
            }
            resolve();
        }
    });
}

export function objectToQueryString(paramObject) {
    return Object.keys(paramObject).map(key => `${key}=${paramObject[key]}`).join('&');
}

export function removeNonPrintableCharacters(value) {
    // eslint-disable-next-line no-control-regex
    const nonPrintableRegex = /[\x00-\x1F]+/g;
    return value.replace(nonPrintableRegex, '');
}

export function objectHasValues(obj) {
    let hasValues = false;
    if (Object.values(obj).length) {
        Object.values(obj).forEach(val => {
            if (val) hasValues = true;
        });
    }
    return hasValues;
}

export function mergeArraysOfObjectsById(a = [], b = []) {
    const seen = new Set();
    const out = [];

    const pushUnique = (arr) => {
        arr.forEach((obj) => {
            if (!obj?.id) return;
            if (!seen.has(obj.id)) {
                seen.add(obj.id);
                out.push(obj);
            }
        });
    };

    pushUnique(a);
    pushUnique(b);
    return out;
}
